import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { BrandMark, BrandWordmark } from '@/components/brand'

export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-page-admin px-4 py-10">
      <div className="mb-8 flex flex-col items-center gap-3 text-center">
        <Link to="/connexion" className="flex flex-col items-center gap-3 no-underline">
          <BrandMark size={56} />
          <BrandWordmark />
        </Link>
        <p className="kicker text-second-admin">Back-office</p>
      </div>
      <div className="w-full max-w-md rounded-2xl border border-bordure-admin bg-white p-6 shadow-sm sm:p-8">
        <h1 className="text-admin-titre text-xl">{title}</h1>
        {subtitle ? <p className="mt-1.5 text-sm text-second-admin">{subtitle}</p> : null}
        <div className="mt-6">{children}</div>
        {footer ? <div className="mt-6 border-t border-bordure-admin pt-4 text-sm">{footer}</div> : null}
      </div>
      <p className="mt-8 text-center text-xs text-second-admin">johnsaks.com · Accès réservé</p>
    </div>
  )
}
